import {Component, Fragment} from "preact";
import {BETS_SEARCH_STATUSES, BETS_STATUS, OUTCOMES_STATUS} from "../../utils/ticket-statuses";
import Session from "../../utils/session";
import Admin from "../../../../services/admin";
import {LazyTree} from "../../utils/users-tree";
import {
    Cell,
    CustomTable,
    EmptyRecordsMessage,
    FiltersRow,
    HCell,
    HRow,
    PaginationV2,
    Panel,
    PanelRow, Row
} from "../../utils/table-utils";
import {
    DateHelperFilter, EventsLeftCountFilter, FromAcceptanceFilter, OutcomeCodeFilter, PerPageFilter,
    SearchTypeFilter,
    TicketEndDateFilter, TicketEventsCountFilter,
    TicketStatusFilter,
    TicketTypeFilter
} from "../../utils/form-utils";
import { msg, t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import TicketLogic from "../../utils/ticket-logic";
import MoneyFormatter from "../../utils/money-formatter";
import OddsFormatter from "../../utils/odds-formatter";
import AwrabetManagerBetslist, {
    BetsTable as AwrabetBetsTable,
    BetsTableRow as AwrabetBetsTableRow
} from "../../../awrabet/desktop-components/user/manager-betslist.jsx";


export default class ManagerBetslist extends AwrabetManagerBetslist {
    render() {
        return <div class="flex flex-row">
            {!!this.state.structures.children && <div class="shrink-0 p-2 text-xs">
                <div class="bg-white border h-full p-3 relative">
                    <a
                        style="left: 100%; top: 40px;"
                        class="absolute p-1 rounded-r border border-l-0 bg-white text-gray-500"
                        onClick={e => {
                            this.state.structures.collapseFilter = !this.state.structures.collapseFilter;
                            this.setState(!this.state);
                        }}
                        href="javascript:void(0);"
                    >
                        {this.state.structures.collapseFilter?
                            <i class="fa fa-caret-right" />
                            : <i class="fa fa-caret-left" />}
                    </a>
                    <div
                        class={"border-l-4 border flex-0 max-h-screen overflow-auto overflow-x-hidden bg-white min-h-full"+(this.state.structures.collapseFilter? ' w-px' : ' w-56')}
                        style="border-left-color: #38b2ac;"
                    >
                        <LazyTree
                            data={this.state.structures.children}
                            loadChildren={(id, cb) => this.getManagerChildren(id, cb)}
                            onNodeSelected={structure => this.filterFromManagerChildren(structure)}
                            currentSelection={this.state.structures.filterid}
                            firstLevelOpen={true}
                        />
                    </div>
                </div>
            </div>}
            <div class="w-full">
                <FiltersRow class="p-2 text-sm items-end justify-center flex-wrap gap-1">
                    <DateHelperFilter
                        helperValue={this.state.input.searchHelper}
                        dateStartValue={this.state.input.searchStartDate}
                        dateEndValue={this.state.input.searchEndDate}
                        onInput={
                            (dateFilter) => {
                                this.state.input.searchHelper = dateFilter.helperValue;
                                this.state.input.searchStartDate = dateFilter.dateStartValue;
                                this.state.input.searchEndDate = dateFilter.dateEndValue;
                                this.setState(this.state);
                            }
                        }
                    />
                    <TicketEndDateFilter
                        useTicketEnd={this.state.input.useTicketEnd}
                        onInput={({useTicketEnd}) => {
                            this.state.input.useTicketEnd = useTicketEnd;
                            this.setState({});
                        }}
                    />
                    <TicketStatusFilter
                        searchStatus={this.state.input.searchStatus}
                        onInput={({searchStatus}) => {
                            this.state.input.searchStatus = searchStatus;
                            this.setState({});
                        }}
                    />
                    <TicketTypeFilter
                        searchBetType={this.state.input.searchBetType}
                        onInput={({searchBetType}) => {
                            this.state.input.searchBetType = searchBetType;
                            this.setState({});
                        }}
                    />
                    <SearchTypeFilter
                        searchType={this.state.input.searchType}
                        searchString={this.state.input.searchString}
                        searchExact={this.state.input.searchExact}
                        onInput={({searchType, searchString, searchExact}) => {
                            this.state.input.searchType = searchType;
                            this.state.input.searchString = searchString;
                            this.state.input.searchExact = searchExact;
                            this.setState({});
                        }}
                    />
                    <FromAcceptanceFilter
                        searchStock={this.state.input.searchStock}
                        onInput={
                            ({searchStock}) => {
                                this.state.input.searchStock = searchStock;
                                this.setState({});
                            }
                        }
                    />
                    <TicketEventsCountFilter
                        searchBetEvents={this.state.input.searchBetEvents}
                        onInput={
                            ({searchBetEvents}) => {
                                this.state.input.searchBetEvents = searchBetEvents;
                                this.setState({});
                            }
                        }
                    />
                    <EventsLeftCountFilter
                        searchForPrese={this.state.input.searchForPrese}
                        onInput={
                            ({searchForPrese}) => {
                                this.state.input.searchForPrese = searchForPrese;
                                this.setState({});
                            }
                        }
                    />
                    <OutcomeCodeFilter
                        searchOutcome={this.state.input.searchOutcome}
                        onInput={
                            ({searchOutcome}) => {
                                this.state.input.searchOutcome = searchOutcome;
                                this.setState({});
                            }
                        }
                    />
                    <PerPageFilter
                        perPage={this.state.input.searchRecordPerPage}
                        pageList={[10,30,45,50,100]}
                        onInput={
                            ({perPage}) => {
                                this.state.input.searchRecordPerPage = perPage;
                                this.setState(this.state);
                            }
                        }
                    />
                    <a
                        href="javascript:void(0);"
                        class="button p-2 ml-5"
                        style="color:var(--main-text-color);"
                        onClick={e => this.performSearch()}
                    >
                        {!this.state.pageloading?
                            <Trans>Avvia Ricerca <i class="fa fa-search"/></Trans>
                            : <Trans>Ricerca In Corso... <i class="fa fa-spin fa-gear"/></Trans>}
                    </a>
                </FiltersRow>
                <div class="text-xs mt-3">
                    <BetsTable
                        {...this.state.response}
                        onIdClick={ticket => TicketLogic.printTicket(ticket)}
                        onNavigation={this.changePage.bind(this)}
                    />
                </div>
            </div>
        </div>;
    }
}

export class BetsTable extends AwrabetBetsTable {
    render({data, onIdClick = null}) {
        return <Panel>
            <PanelRow>
                {!this.state.data.length?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        <CustomTable style="font-family:'Arial rounded', Arial, sans-serif;" class="w-full table-auto border border-l-0 border-b-0 main-text-color">
                            <thead class="text-center font-bold bg-gray-200 body-bg-color">
                            <HRow>
                                <HCell><Trans>ID e Data</Trans></HCell>
                                <HCell><Trans>Username</Trans></HCell>
                                <HCell><Trans>IP & Dispositivo</Trans></HCell>
                                <HCell><Trans>Tipo Scommessa</Trans></HCell>
                                <HCell><Trans>Data Scommessa / Termine</Trans></HCell>
                                <HCell><Trans>N. Eventi</Trans></HCell>
                                <HCell><Trans>Puntata</Trans></HCell>
                                <HCell><Trans>Vincita</Trans></HCell>
                                <HCell><Trans>Stato</Trans></HCell>
                                <HCell />
                            </HRow>
                            </thead>
                            <tbody class="text-center">
                            {this.state.data.map((bet,i) => <BetsTableRow key={'managerbetrow'+i} row={bet} onIdClick={onIdClick} />)}
                            </tbody>
                        </CustomTable>
                        {!!this.state.onNavigation && <PaginationV2
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => {this.state.onNavigation(page, page*this.state.recordperpage-this.state.recordperpage)}}
                            isLastPage={this.state.totalpages===this.state.page}
                        />}
                    </Fragment>}
            </PanelRow>
        </Panel>;
    }
}

export class BetsTableRow extends AwrabetBetsTableRow {
    renderMultiCurrencyField(multicurrencydata) {
        return Object.entries(multicurrencydata)
            .filter(([k,v]) => k !== '')
            .map(
                ([currency,amount]) => <MoneyFormatter
                    value={amount}
                    currency={currency}
                />
            );
    }

    renderPrematchDetails(details) {
        return Object.values(details).map(
            item => <Row class="betstable-details-row">
                <Cell class="w-1/10 p-2 border-r betstable-border-color">{this.printDateFormat(item.data_evento_ts * 1000)}</Cell>
                <Cell class="w-4/10 p-2 text-left border-r betstable-border-color">
                    <div class="flex items-center justify-center">
                        <span class="w-full">{item.evento}</span>
                        {!!item.risultato && <span class="shrink-0 grow-0 flex flex-col items-center justify-center text-center gap-1">
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>FT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.risultato['@CASA'] != 'undefined' && item.risultato['@CASA'] !== null? item.risultato['@CASA'] + '-' : ''}
                                    {typeof item.risultato['@FUORI'] != 'undefined' && item.risultato['@FUORI'] !== null? item.risultato['@FUORI']: ''}
                                </span>
                            </span>
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>HT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.risultato['@CASAPT'] != 'undefined' && item.risultato['@CASAPT'] !== null? item.risultato['@CASAPT'] + '-' : ''}
                                    {typeof item.risultato['@FUORIPT'] != 'undefined' && item.risultato['@FUORIPT'] !== null? item.risultato['@FUORIPT']: ''}
                                </span>
                            </span>
                        </span>}
                    </div>
                </Cell>
                <Cell class="w-3/10 p-2 text-left border-r betstable-border-color">{item.scommessa} - {item.esito}</Cell>
                <Cell class="w-1/10 p-2 font-bold border-r betstable-border-color main-color"><OddsFormatter odds={item.quota} /></Cell>
                <Cell class="w-1/10 p-2">
                    {!!item.status && <div class="flex flex-row">
                        <span class="w-full">{this.outcomeStatusDescription(item.status)}</span>
                        <span class={'w-full text-right ' + (item.status==='P'? 'text-red-600' : 'text-green-600')}>
                            <i class={"fa "+ (item.status==='P'? 'fa-circle-xmark' : 'fa-check-circle')} />
                        </span>
                    </div>}
                </Cell>
            </Row>
        );
    }

    renderLiveDetails(details) {
        return details.map(
            item => <Row class="betstable-details-row">
                <Cell class="w-1/10 p-2 border-r betstable-border-color">{!!item.event.datets? this.printDateFormat(item.event.datets * 1000) : ''}</Cell>
                <Cell class="w-4/10 p-2 text-left border-r betstable-border-color">
                    <div class="flex items-center justify-center">
                        <span class="w-full">{item.event.name}</span>
                        {!!item.event.results && <span class="shrink-0 grow-0 flex flex-col items-center justify-center text-center gap-1">
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>FT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.event.results['@CASA'] != 'undefined' && item.event.results['@CASA'] !== null? item.event.results['@CASA'] + '-' : ''}
                                    {typeof item.event.results['@FUORI'] != 'undefined' && item.event.results['@FUORI'] !== null? item.event.results['@FUORI']: ''}
                                </span>
                            </span>
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>HT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.event.results['@CASAPT'] != 'undefined' && item.event.results['@CASAPT'] !== null? item.event.results['@CASAPT'] + '-' : ''}
                                    {typeof item.event.results['@FUORIPT'] != 'undefined' && item.event.results['@FUORIPT'] !== null? item.event.results['@FUORIPT']: ''}
                                </span>
                            </span>
                        </span>}
                    </div>
                </Cell>
                <Cell class="w-3/10 p-2 text-left border-r betstable-border-color">{item.outcome.market} - {item.outcome.name}</Cell>
                <Cell class="w-1/10 p-2 font-bold border-r betstable-border-color main-color"><OddsFormatter odds={item.outcome.odd} /></Cell>
                <Cell class="w-1/10 p-2">
                    {!!item.outcome.status && <div class="flex flex-row">
                        <span class="w-full">{this.outcomeStatusDescription(item.outcome.status)}</span>
                        <span class={'w-full text-right ' + (item.outcome.status==='L'? 'text-red-500' : 'text-green-500')}>
                            <i class={"fa "+ (item.outcome.status==='L'? 'fa-circle-xmark' : 'fa-check-circle')} />
                        </span>
                    </div>}
                </Cell>
            </Row>
        );
    }

    render({row, onIdClick = null}) {
        const ticket = row.ticket;
        const user = row.user;
        const eventswinnercount = Object.values(ticket.details).reduce(
            (carry, item) => {
                if (!!item.status && item.status !== 'P') {
                    ++carry;
                } else if (!!item.outcome && !!item.outcome.status && item.outcome.status !== 'L') {
                    ++carry;
                }
                return carry;
            },
            0
        );
        return <Fragment>
            <Row class="betstable-main-row align-middle">
                <Cell>
                    <a
                        href="javascript:void(0);"
                        class="betstable-print-button whitespace-pre px-1"
                        onClick={e => !!onIdClick && onIdClick({id: ticket['internal-id'], code: ticket.id})}
                    >
                        <i class="fa fa-print main-color mr-2"/>
                        {ticket.id}
                    </a>
                    <span class="block text-xxs leading-3 pb-1 betstable-cell-text-color-dark">
                        {ticket['live-id']}
                    </span>
                </Cell>
                <Cell class="text-left px-3 font-bold">
                    <span class="block main-color">
                        {!!user.iscashier && <i class="fa fa-cash-register text-white mr-1" title={window.Translation(msg`Cassa`)} />}
                        {user.username}
                    </span>
                    <span class="block text-xxs betstable-cell-text-color-dark">
                        {!!user.isactive?
                            <i class="fa-solid fa-circle-check text-green-600 mr-1" title={window.Translation(msg`User Attiva`)} />
                            : <i class="fa-solid fa-circle-xmark text-red-600 mr-1" title={window.Translation(msg`User Non Attiva`)} />}
                        {!!user.isbanned && <i class="fa-solid fa-ban text-red-600 mr-1" title={window.Translation(msg`User Bannata`)} />}
                        {!!user.isinvestigation && <i class="fa-solid fa-magnifying-glass text-orange-600 mr-1" title={window.Translation(msg`User In Investigazione`)} />}
                        #{user.id}
                    </span>
                </Cell>
                <Cell>
                    <span class="block text-xxs">{user.ip}</span>
                    <span class="block pt-1">
                        {!!user.isAndroid && <i class="fa-brands fa-android text-green-500 mx-1" title={window.Translation(msg`Android`)} />}
                        {!!user.isIos && <i class="fa-brands fa-apple text-white mx-1" title={window.Translation(msg`IOS`)} />}
                        {!!user.isDesktop && <i class="fa fa-desktop main-color mx-1" title={window.Translation(msg`Desktop`)} />}
                        {!!user.isTablet && <i class="fa fa-tablet main-color mx-1" title={window.Translation(msg`Tablet`)} />}
                        {!!user.isMobile && <i class="fa fa-mobile main-color mx-1" title={window.Translation(msg`Mobile`)} />}
                        {!!user.isOtherDevice && <i class="fa-solid fa-circle-question main-color mx-1" title={window.Translation(msg`Dispositivo Sconosciuto`)} />}
                    </span>
                </Cell>
                <Cell>{ticket.typedesc}</Cell>
                <Cell>
                    <span class="block py-1">
                        {this.printDateFormat(ticket.betdatets * 1000)}
                    </span>
                    <span class="block pb-1">
                        {this.printDateFormat(ticket.enddatets * 1000)}
                    </span>
                </Cell>
                <Cell>
                    {ticket.eventscount}
                    {!!eventswinnercount? <span> / <span class="text-green-600 font-bold">{eventswinnercount}</span></span> : ''}
                </Cell>
                <Cell class="p-1">
                    {this.renderMultiCurrencyField(ticket.betamount)}
                </Cell>
                <Cell class="p-1">
                    {ticket.statuscode === 'N'?
                        <span class="betstable-cell-text-color-dark font-bold">{this.renderMultiCurrencyField(ticket.potentialwin)}</span>
                        : (ticket.statuscode === 'P'?
                                <span class="text-red-600 font-bold">{this.renderMultiCurrencyField(ticket.winamount)}</span>
                                : (ticket.statuscode === 'V'?
                                    <span class="text-green-600 font-bold">{this.renderMultiCurrencyField(ticket.winamount)}</span>
                                    : <span>-</span>)
                        )}
                </Cell>
                <Cell>
                    <span class="flex flex-row items-center justify-center">
                        <span class="w-full text-xs font-bold text-left mr-1">{BETS_STATUS(ticket.statuscode)}</span>
                        {this.statusIcon(ticket)}
                    </span>
                </Cell>
                <Cell>
                    <a
                        href="javascript:void(0);"
                        class="block px-2"
                        onClick={e => this.setState({showdetails: !this.state.showdetails})}
                    >
                        <i class={"fa "+ (!this.state.showdetails? 'fa-chevron-down' : 'fa-chevron-up')} />
                    </a>
                </Cell>
            </Row>
            {!!this.state.showdetails && <Row>
                <Cell colspan="10">
                    <CustomTable class="w-full border-b-4 text-xs font-sans" style="border-color:var(--main-color);">
                        <tbody>
                        {ticket.typecode === 'L'?
                            this.renderLiveDetails(ticket.details)
                            : this.renderPrematchDetails(ticket.details)}
                        </tbody>
                    </CustomTable>
                </Cell>
            </Row>}
            <Row>
                <Cell colspan="10" class="border-0 p-0">
                    {/* Riga bianca di separazione fra le singole scommesse */}
                    <div class="block w-full py-px" />
                </Cell>
            </Row>
        </Fragment>;
    }
}